
import React, { useEffect, useState } from "react";
import { Routes, Route, BrowserRouter, Navigate, useLocation, useNavigate } from "react-router-dom";
import { AuthPage, Logout } from "../components/auth";
import {
  AUTH_TOKEN,
  CIRCLEONE_LOGIN_TYPE,
  CUST_ID,
  GARAGE_ID,
  GARAGE_ROLE,
  GARAGE_TOKEN,
  WORKSHOP_ENDTIME,
  WORKSHOP_HOLIDAY,
  WORKSHOP_ID,
  WORKSHOP_STARTTIME,
} from "../constants";
import { PrivateRoutes } from "./PrivateRoutes";
import App from "../components/app/app";
import UserVerifiedPage from "../components/auth/components/UserVerifiedPage";
import ClinetLoginRoute from "..//pages/clientLogin/index";
import OtpPage from "../components/auth/components/OtpPage";
// import ErrorPage from "../components/auth/components/ErrorPage";
import MyProfile from "../pages/profile/Profile";

import ReactModal from "react-modal";
import NotificationModal from "../pages/campaign/leads/NotificationModal";
import { useWebSocket } from "../context/WebSocketContext";
import { useNotification } from "../context/NotificationModalContenxt";

// import HomePage from "../components/auth/components/HomePage";
import CustomerMasterLayout from "../layout/CustomerMasterLayout";
import HomePage from "../pages/customerPprofile/UpdatedUi/HomePage";
import ContactUs from "../pages/customerPprofile/UpdatedUi/ContactUs";
import AboutUs from "../pages/customerPprofile/AboutUs";
import { Modal } from "@mui/material";

import WorkshopLocator from "../pages/customerPprofile/WorkshopLocator";
import AllServices from "../pages/customerPprofile/UpdatedUi/AllServices";
import CustomerLogin from "../components/auth/components/CustomerLogin";
import axios from "axios";
import CustomerPrivateRoutes from "./CustomerPrivateRoutes";
import WorkshopAdminPrivateRoutes from "./WorkshopAdminPrivateRoutes";
import WorkshopPrivateRoutes from "./WorkshopPrivateRoutes";
import VehicleModal from "../pages/customerPprofile/VehicleModal";
import WorkshopRequestOnboard from "../pages/vehicle/workshop/WorkshopRequestOnboard";
import PolicyModal from "../components/auth/components/PrivacyModal";


import LeadThankYouPage from "../pages/customerPprofile/LeadThankYouPage";
import LeadGenerationPage from "../pages/customerPprofile/LeadGenerationPage";
import FloatingBookNowBtn from "./FloatingBookNowBtn";
import GTMManager from "./GTMManager";

const { PUBLIC_URL } = process.env;

// Routes where lead generation should auto-trigger
// const LEAD_GENERATION_ROUTES = [
//   "/home",
//   "/join-us",
//   "/customer/services",
//   "/customer/about-us",
//   "/customer/contact-us",
// ];

// Component to handle auto-opening lead generation page
// const LeadGenerationHandler: React.FC<{
//   isLoggedIn: boolean;
// }> = ({ isLoggedIn }) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [inactivityTimer, setInactivityTimer] = useState<NodeJS.Timeout | null>(
//     null
//   );

//   // Track if lead generation has been shown (persists in localStorage)
//   const [hasShownLeadGen, setHasShownLeadGen] = useState(() => {
//     return localStorage.getItem("leadGenShown") === "true";
//   });

//   // Check if current route should trigger lead generation
//   const shouldTriggerLeadGen = LEAD_GENERATION_ROUTES.includes(
//     location.pathname
//   );

//   // Auto-navigate to lead generation after 5 seconds on allowed routes (only once)
//   useEffect(() => {
//     if (!isLoggedIn && shouldTriggerLeadGen && !hasShownLeadGen) {
//       const timer = setTimeout(() => {
//         navigate("/enquiry", { state: { from: location.pathname } });
//         setHasShownLeadGen(true);
//         localStorage.setItem("leadGenShown", "true");
//       }, 5000); // 5 seconds

//       return () => clearTimeout(timer);
//     }
//   }, [
//     isLoggedIn,
//     shouldTriggerLeadGen,
//     hasShownLeadGen,
//     location.pathname,
//     navigate,
//   ]);

//   // Inactivity detection - navigate to lead generation after 5 seconds of no activity
//   useEffect(() => {
//     if (!isLoggedIn && shouldTriggerLeadGen && !hasShownLeadGen) {
//       const resetTimer = () => {
//         if (inactivityTimer) {
//           clearTimeout(inactivityTimer);
//         }

//         const timer = setTimeout(() => {
//           navigate("/enquiry", { state: { from: location.pathname } });
//           setHasShownLeadGen(true);
//           localStorage.setItem("leadGenShown", "true");
//         }, 5000); // 5 seconds of inactivity

//         setInactivityTimer(timer);
//       };

//       // Events that indicate user activity
//       const activityEvents = [
//         "mousedown",
//         "mousemove",
//         "keypress",
//         "scroll",
//         "touchstart",
//         "click",
//       ];

//       activityEvents.forEach((event) => {
//         document.addEventListener(event, resetTimer);
//       });

//       // Start the initial timer
//       resetTimer();

//       // Cleanup
//       return () => {
//         if (inactivityTimer) {
//           clearTimeout(inactivityTimer);
//         }
//         activityEvents.forEach((event) => {
//           document.removeEventListener(event, resetTimer);
//         });
//       };
//     }
//   }, [
//     isLoggedIn,
//     shouldTriggerLeadGen,
//     hasShownLeadGen,
//     location.pathname,
//     navigate,
//   ]);

//   return null;
// };

const MainAppRoutes: React.FC = () => {
  const {
    isNotificationModalOpen,
    socketData,
    openNotificationModal,
    closeNotificationModal,
  } = useNotification();

  const [liftingName, setLiftingName] = useState<any>("");
  const [storeGeoLocationData, setStoreGeoLocationData] = useState<any>("");
  const [storeVehicleInfo, setStoreVehicleInfo] = useState<any>({});
  const [openVehicleModal, setOpenVehicleModal] = useState(false);
  const [openModal, setOpenModal] = useState("");
  const isSuperAdminLoggedIn = localStorage.getItem("super-user");
  const isCustomerLoggedIn = localStorage.getItem("customer");
  const isGarageAdminLoggedIn = localStorage.getItem(GARAGE_ROLE);
  const [isWorkshopSelectorClicked, setIsWorkshopSelectorClicked] =
    useState<boolean>(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [vehicleData, setVehicleData] = useState([]);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [workshopId, setWorkshopId] = useState("");
  const [isCheckoutClicked, setIsCheckoutClicked] = useState(false);
  const [cartItems, setCartItems] = useState<any[]>([]);
  const [liftingSlot, setLiftingSlot] = useState(false);
  const [isSubServiceModalOpen, setIsSubServiceModalOpen] = useState(false);
  const [homeApiData, setHomeApiData] = useState([]);

  const getUserId = localStorage.getItem(CUST_ID);

  const apiPort = process.env.REACT_APP_API_PROTOCOL;
  const token = localStorage.getItem("customer-token");

  const socket = useWebSocket();

  //  const location = useLocation();
  const fetchingTenant = window.location.hostname.split(".")[0];

  console.log(fetchingTenant, "fetchingTenant");

  // Check if any user is logged in
  const isAnyUserLoggedIn = !!(
    isCustomerLoggedIn ||
    isSuperAdminLoggedIn ||
    isGarageAdminLoggedIn
  );

  useEffect(() => {
    if (
      isCustomerLoggedIn &&
      window.location.pathname === "/auth/admin-login"
    ) {
      localStorage.clear();
      // localStorage.removeItem("customer-token");
      //           localStorage.removeItem("login-type");
      //           localStorage.removeItem(CUST_ID);
      window.location.replace("/auth/admin-login");
    }
  }, []);

  useEffect(() => {
    if (
      isCustomerLoggedIn &&
      window.location.pathname === "/auth/workshop-admin-login"
    ) {
      localStorage.clear();
      //  localStorage.removeItem("customer-token");
      //             localStorage.removeItem("login-type");
      //             localStorage.removeItem(CUST_ID);
      window.location.replace("/auth/workshop-admin-login");
    }
  }, []);

  useEffect(() => {
    if (getUserId) {
      homeApi();
    }
  }, [getUserId]);

  const homeApi = async () => {
    try {
      const response = await axios.get(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/home/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setHomeApiData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  // console.log(location, "LOCATIONN")

  // const location = useLocation()
  // console.log(location, "locationsnss")

  useEffect(() => {
    const serverResponse = socket?.state?.serverResponse?.[0]?.data;
    if (serverResponse) {
      openNotificationModal(serverResponse);
    }
  }, [socket, socket?.state?.serverResponse]);

  const isAuthorized = localStorage.getItem(AUTH_TOKEN); // User authentication logic should be inserted here
  const loginType = (() => {
    const item = localStorage.getItem(CIRCLEONE_LOGIN_TYPE);
    if (item) {
      try {
        return JSON.parse(item);
      } catch (error) {
        return false;
      }
    }
    return false;
  })();

  useEffect(() => {
    if (
      isGarageAdminLoggedIn === "garage_admin" &&
      window.location.pathname === "/auth/admin-login"
    ) {
      // localStorage.removeItem(GARAGE_TOKEN)
      //           localStorage.removeItem(GARAGE_ROLE)
      //           localStorage.removeItem(GARAGE_ID)
      //           localStorage.removeItem(WORKSHOP_ID)
      //           localStorage.removeItem( WORKSHOP_HOLIDAY)
      //           localStorage.removeItem( WORKSHOP_STARTTIME)
      //           localStorage.removeItem( WORKSHOP_ENDTIME)
      localStorage.clear();
      window.location.replace("/auth/admin-login");
    }
  }, []);

  useEffect(() => {
    if (
      isGarageAdminLoggedIn === "garage_tenant_admin" &&
      window.location.pathname === "/auth/workshop-admin-login"
    ) {
      //  localStorage.removeItem(GARAGE_TOKEN)
      //         localStorage.removeItem(GARAGE_ROLE)
      localStorage.clear();
      window.location.replace("/auth/workshop-admin-login");
    }
  }, []);

  const closeCartModal = () => {
    setIsCartOpen(false);
    // setCurrentStep(1)
  };

  const checkoutServices = () => {
    setIsCheckoutClicked(true);
  };
  const handleRemoveFromCart = (subServiceId: string) => {
    const updatedCart = cartItems.filter(
      (item) => item.sub_service?.id !== subServiceId
    );
    setCartItems(updatedCart);
    // updateSessionStorage(updatedCart);
  };

  console.log(isCartOpen, "sdcsccscd");

  const customModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "450px",
    },
  };

  const fetchVehicle = async () => {
    try {
      const response = await axios.get(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/vehicles/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setVehicleData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  useEffect(() => {
    if (fetchingTenant === "ercs") {
      fetchVehicle();
    }
  }, [isOtpVerified]);

  const closeModal = () => {
    setIsSubServiceModalOpen(false);
    setIsCartOpen(false);
    setOpenModal("");
  };

  const onClose = () => {
    setOpenVehicleModal(false);
  };

  return (
    <>
      <BrowserRouter basename={PUBLIC_URL}>
     
        {<FloatingBookNowBtn />}
        {<GTMManager />}
        
        {/* Lead Generation Handler - Auto-navigates when conditions are met */}
        {/* <LeadGenerationHandler isLoggedIn={isAnyUserLoggedIn} /> */}

        <Routes>
          {/* Lead Generation Route - accessible to all (not logged in users) */}
          <Route path="/enquiry" element={<LeadGenerationPage />} />

          {/* Thank You Route - accessible to all */}
          <Route path="/thank-you" element={<LeadThankYouPage />} />

          <Route
            path="customer/privacy-policy"
            element={<PolicyModal closeModal={undefined} />}
          />
          {/* 👇 Your independent /home route inside CustomerMasterLayout */}
          <Route
            element={
              <CustomerMasterLayout
                liftingName={liftingName}
                setStoreGeoLocationData={setStoreGeoLocationData}
                storedGeoLoaction={storeGeoLocationData}
                setStoreVehicleInfo={setStoreVehicleInfo}
                storeVehicleInfo={storeVehicleInfo}
                setOpenVehicleModal={setOpenVehicleModal}
                setOpenModal={setOpenModal}
                setIsWorkshopSelectorClicked={setIsWorkshopSelectorClicked}
                setIsCartOpen={setIsCartOpen}
                vehicleData={vehicleData}
                setCurrentStep={setCurrentStep}
                homeApiData={homeApiData}
              />
            }
          >
            <Route
              path="customer/contact-us"
              element={
                <ContactUs
                  setIsWorkshopSelectorClicked={setIsWorkshopSelectorClicked}
                />
              }
            />
            <Route path="customer/about-us" element={<AboutUs />} />
            <Route
              path="join-us"
              element={<WorkshopRequestOnboard closeModal={undefined} />}
            />

            <Route
              path="customer/services"
              element={
                <AllServices
                  setIsCartOpen={setIsCartOpen}
                  setOpenVehicleModal={setOpenVehicleModal}
                  setVehicleData={setVehicleData}
                  vehicleData={vehicleData}
                  setOpenModal={setOpenModal}
                  setCurrentStep={setCurrentStep}
                  setIsSubServiceModalOpen={setIsSubServiceModalOpen}
                  isSubServiceModalOpen={isSubServiceModalOpen}
                />
              }
            />
            <Route
              path="/home"
              element={
                <HomePage
                  setOpenVehicleModal={setOpenVehicleModal}
                  openVehicleModal={openVehicleModal}
                  setStoreVehicleInfo={setStoreVehicleInfo}
                  storeVehicleInfo={storeVehicleInfo}
                  storeGeoLocationData={storeGeoLocationData}
                  setStoreGeoLocationData={setStoreGeoLocationData}
                  openModal={openModal}
                  setOpenModal={setOpenModal}
                  isWorkshopSelectorClicked={isWorkshopSelectorClicked}
                  setIsWorkshopSelectorClicked={setIsWorkshopSelectorClicked}
                  setIsCartOpen={setIsCartOpen}
                  isCartOpen={isCartOpen}
                  setVehicleData={setVehicleData}
                  vehicleData={vehicleData}
                  setIsOtpVerified={setIsOtpVerified}
                  isOtpVerified={isOtpVerified}
                />
              }
            />
          </Route>

          {/* {isSuperAdminLoggedIn && (
          <Route path="/*" element={<SuperAdminPrivateRoutes />} />
        )} */}
          {isCustomerLoggedIn && (
            <Route
              path="/*"
              element={
                <CustomerPrivateRoutes
                  setWorkshopId={setWorkshopId}
                  workshopId={workshopId}
                  storeGeoLocationData={storeGeoLocationData}
                  setStoreGeoLocationData={setStoreGeoLocationData}
                  setLiftingSlot={setLiftingSlot}
                  setIsCheckoutClicked={setIsCheckoutClicked}
                  setCurrentStep={setCurrentStep}
                  currentStep={currentStep}
                  homeApiData={homeApiData}
                />
              }
            />
          )}
          {isGarageAdminLoggedIn === "garage_admin" && (
            <Route path="/*" element={<WorkshopAdminPrivateRoutes />} />
          )}
          {isGarageAdminLoggedIn === "garage_tenant_admin" && (
            <Route path="/*" element={<WorkshopPrivateRoutes />} />
          )}

          {/* 👇 Fallback authenticated or public routes */}
          {!isSuperAdminLoggedIn &&
            !isCustomerLoggedIn &&
            !isGarageAdminLoggedIn && (
              <>
                {isAuthorized ? (
                  <>
                    {loginType === true ? (
                      <>
                        <Route
                          path="/client-login/*"
                          element={<ClinetLoginRoute />}
                        />
                        <Route path="/profile" element={<MyProfile />} />
                        <Route path="logout" element={<Logout />} />
                        <Route
                          path="*"
                          element={<Navigate to="/client-login" />}
                        />
                      </>
                    ) : (
                      <>
                        <Route element={<App />}>
                          <Route path="/*" element={<PrivateRoutes />} />
                          <Route
                            path="/client-login/*"
                            element={<ClinetLoginRoute />}
                          />
                          <Route path="/profile" element={<MyProfile />} />
                          <Route path="logout" element={<Logout />} />
                        </Route>
                        {/* <Route path="*" element={<ErrorPage />} /> */}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <Route path="auth/*" element={<AuthPage />} />
                    <Route path="/verify-email" element={<OtpPage />} />
                    <Route path="verification" element={<UserVerifiedPage />} />
                    <Route path="*" element={<Navigate to="/auth" />} />
                  </>
                )}
              </>
            )}
        </Routes>
      </BrowserRouter>

      {/* 👇 Modal Outside Router */}
      <ReactModal
        isOpen={isNotificationModalOpen}
        onRequestClose={closeNotificationModal}
        contentLabel="Notification Modal"
      >
        <NotificationModal
          close={closeNotificationModal}
          socketData={socketData}
        />
      </ReactModal>

      <Modal
        open={isWorkshopSelectorClicked}
        onClose={() => {
          setIsWorkshopSelectorClicked(false);
        }}
      >
        <WorkshopLocator
          setStoreGeoLocationData={setStoreGeoLocationData}
          storedGeoLoaction={storeGeoLocationData}
          onClose={() => setIsWorkshopSelectorClicked(false)}
        />
      </Modal>

      <ReactModal
        isOpen={openModal === "login"}
        onRequestClose={closeModal}
        style={customModalStyles}
        contentLabel="Change Status"
      >
        <CustomerLogin
          setOpenModal={setOpenModal}
          fetchVehicles={fetchVehicle}
          setIsOtpVerified={setIsOtpVerified}
        />
      </ReactModal>
      {openVehicleModal && (
        <VehicleModal
          fetchVehicle={fetchVehicle}
          vehicle={undefined}
          onClose={onClose}
        />
      )}
    </>
  );
};

export { MainAppRoutes };
